/** EMBER & PALM — factual Restaurant schema only; no self-serving aggregate rating markup. */
import { SITE } from "@/lib/site";

const schema = {
  "@context": "https://schema.org",
  "@type": "Restaurant",
  "@id": "https://www.angkorflavours.com.au/#restaurant",
  name: SITE.name,
  description:
    "Authentic Cambodian restaurant and bar in West Melbourne serving Fish Amok, family recipes, Khmer curries, grills and Cambodian-inspired drinks.",
  url: "https://www.angkorflavours.com.au/",
  telephone: SITE.phone,
  email: SITE.email,
  priceRange: "$$",
  servesCuisine: ["Cambodian", "Khmer"],
  image: [
    "https://www.angkorflavours.com.au/manus-storage/fish-amok-premium_857a8cbd.webp",
    "https://www.angkorflavours.com.au/manus-storage/angkor-restaurant-interior-west-melbourne_b573dae6.webp",
    "https://www.angkorflavours.com.au/manus-storage/khmer-grill-sharing-platter-angkor_3fd18469.webp",
  ],
  logo: "https://www.angkorflavours.com.au/android-chrome-512x512.png",
  address: {
    "@type": "PostalAddress",
    streetAddress: "389 Spencer Street",
    addressLocality: "West Melbourne",
    addressRegion: "VIC",
    postalCode: "3003",
    addressCountry: "AU",
  },
  geo: { "@type": "GeoCoordinates", latitude: SITE.geo.lat, longitude: SITE.geo.lng },
  openingHoursSpecification: [
    { "@type": "OpeningHoursSpecification", dayOfWeek: ["Tuesday", "Wednesday", "Thursday"], opens: "11:30", closes: "15:00" },
    { "@type": "OpeningHoursSpecification", dayOfWeek: ["Tuesday", "Wednesday", "Thursday"], opens: "16:30", closes: "21:30" },
    { "@type": "OpeningHoursSpecification", dayOfWeek: "Friday", opens: "11:30", closes: "21:30" },
    { "@type": "OpeningHoursSpecification", dayOfWeek: "Saturday", opens: "12:00", closes: "21:30" },
    { "@type": "OpeningHoursSpecification", dayOfWeek: "Sunday", opens: "16:30", closes: "21:30" },
  ],
  hasMenu: "https://www.angkorflavours.com.au/menu",
  hasMap: "https://maps.google.com/?q=389+Spencer+Street+West+Melbourne+VIC+3003",
  acceptsReservations: true,
  sameAs: [SITE.instagram, SITE.facebook, SITE.tiktok],
  potentialAction: [
    { "@type": "ReserveAction", target: SITE.booking },
    { "@type": "OrderAction", target: SITE.directOrder },
  ],
};

export function RestaurantSchema() {
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}
